<script>
export default {
  name: 'BtnListaReboquesMap',
  data () {
    return {
      showText: true
    }
  },
  methods: {
    toggleButton () {
      this.showText = !this.showText
    },
    onClick () {
      this.$emit('click')
      this.toggleButton()
    }
  }
}
</script>

<template>
  <a @click="onClick" class="btn btn-lista-reboques-mapa">
    <div v-show="showText">
      <img src="../../assets/img/btn-icone-reboque.png" height="35"> <span v-show="showText">Listar reboquistas</span>
    </div>
    <div v-show="!showText"><span style="height: 35px; width: 35px"><i class="fa fa-times fa-2x"></i></span></div>
  </a>
</template>

<style scoped>
</style>



// WEBPACK FOOTER //
// BtnListaReboquesMap.vue?e31c103a